import React, { useState } from "react";
import { useGetGameSelection } from "../../../utils/useGameSelection";
import GameSelectionList from "./GameSelectionList";
import { TermType, useGetTerm } from "../../../utils/useTerm";

const GameSelectionListContainer: React.FC = () => {
  const [searchWord, setSearchWord] = useState<string>();

  const { termData: terms, getTermLoading: gameLoading } = useGetTerm(
    TermType.Games,
    undefined,
    -1,
    searchWord
  );
  const { gameSelections, isLoading } = useGetGameSelection();

  return (
    <GameSelectionList
      isLoading={isLoading || gameLoading}
      gameSelections={gameSelections}
      games={terms.entries}
      handleSearch={(keyword: string) => {
        setSearchWord(keyword ? keyword : undefined);
      }}
    />
  );
};

export default GameSelectionListContainer;
